<div class="loader-backdrop" *ngIf="active$ | async">
  <div class="loader-center">
    <div class="spinner-border text-light" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
